import { Component, inject, input, model, afterNextRender, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../../notification/notification.service';
import { NumberRestrictionDirective } from '../../directives/number-restriction.directive';
import { ResolutionService } from '../../resolution.service';

@Component({
  selector: 'app-change-quantity-subscription',
  imports: [
    FormsModule,
    NumberRestrictionDirective
  ],
  templateUrl: './change-quantity-subscription.component.html',
  styleUrl: './change-quantity-subscription.component.scss'
})
export class ChangeQuantitySubscriptionComponent {

  //#region Services

  #activeModal = inject(NgbActiveModal);

  #notificationService = inject(NotificationService);

  #resolutionService = inject(ResolutionService);

  //#endregion

  //#region Properties

  quantity = input.required<number>();

  quantityModel = model(0);

  isMobile = computed(() => this.#resolutionService.isMobile());

  //#endregion

  //#region Constructor

  constructor() {
    afterNextRender(() => {
      this.quantityModel.set(this.quantity());
      document.getElementById("txtQuantity")?.focus();
    });
  }

  //#endregion

  //#region Methods

  cancel() {
    this.#activeModal.close();
  }

  confirm() {

    if (!this.quantityModel() || this.quantityModel() <= 0) {
      document.getElementById("txtQuantity")?.focus();
      return this.#notificationService.show({
        text: 'Quantity must be greater than zero.',
        type: 'warning'
      });
    }

    this.#activeModal
      .close({ next: true, quantity: this.quantityModel() });
  }

  //#endregion
}
